@use '~/theme/theme' as *;

.hstack {
  display: flex;
  overflow: visible;
}

.vstack {
  display: flex;
  flex-direction: column;
}

.alignCenter {
  align-items: center;
}

.alignEnd {
  align-items: flex-end;
}

.alignStart {
  align-items: flex-start;
}

.justifyEnd {
  justify-content: end;
}

.justifyCenter {
  justify-content: center;
}

.justifyStart {
  justify-content: start;
}

.justifySpaceBetween {
  justify-content: space-between;
}
